export const keysNotToBeShown = ['tenantId', 'language', 'createdAt', 'updatedAt', 'multiLanguageSupportId']
